import { useEffect, useState } from "react"
import Modal from 'react-bootstrap/Modal'
import Button from '@mui/material/Button'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/Form'

import { Control, SettingsGroup } from "../../../Modules/General"

import FontModule from "../../../Modules/FontModule"
import VariableModule from "../../../Modules/VariableModule"
import DataListModal from "../../DataModals/DataListModal"
import CustomSelect from "../../../../Form/CustomSelect"

import * as Basic from "../../../Modules/BasicFields"

const minimalVariables = [
    {name:'Output', key:'output', type:'W'},
    {name:'Min hastags', key:'min-hashtags', type:'W'},
    {name:'Hastags count', key:'hashtags-count', type:'W'}
]

export default function Minimal( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const modalOpen = props.modalOpen
    const selected = props.selected
    const reset = props.reset

    const [ presetList, setPresetList ] = useState(null)
    const [ font, setFont ] = useState(null)
    const [ variables, setVariables ] = useState(null)

    const [ startHashtag, setStartHashtag ] = useState(null)
    const [ stopHashtag, setStopHashtag ] = useState(null)
    const [ minHashtags, setMinHashtags ] = useState(null)
    const [ hashtagRate, setHashtagRate ] = useState(null)

    const [ showModal, setShowModal ] = useState(false)

    const requiredData = [
        presetList,
        font,
        variables,
        startHashtag,
        stopHashtag,
        minHashtags,
        hashtagRate
    ]

    const cfgName = "rng_minimal_cfg"

    const reload = () => {
        let properties = dynoCfg.properties

        let cfg = properties[cfgName] || {}

        setFont( cfg.font || {})
        setVariables( cfg.variables || {} )
        setPresetList( cfg.preset_list || [] )
        setStartHashtag( cfg.start_hashtag || "" )
        setStopHashtag( cfg.stop_hashtag || "" )
        setMinHashtags( (cfg.min_hashtags != null) ? cfg.min_hashtags : 1 )
        setHashtagRate( cfg.hashtag_rate || "one_per_user" )
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {

        if( requiredData.includes(null) )
        {
            return
        }

        let data = {}
        data.font = font 
        data.variables = variables
        data.preset_list = presetList
        data.start_hashtag = startHashtag 
        data.stop_hashtag = stopHashtag 
        data.min_hashtags = minHashtags 
        data.hashtag_rate = hashtagRate 
    
        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ font, variables, presetList, startHashtag, stopHashtag, minHashtags, hashtagRate ])

    useEffect( () => {
        modalOpen.current = showModal
    },[showModal])

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <>
            <SettingsGroup name="Behaviour">
                <Basic.ButtonInput name="Edit list" onClick={ e => setShowModal(true)} />
            </SettingsGroup>

            <FontModule font={font} 
                        setFont={setFont}
                        selected={selected}
                        reset={reset}
            />
            <VariableModule variables={variables} 
                            setVariables={setVariables} 
                            variableList={minimalVariables}
                            reset={reset}
            />

            <SettingsGroup name="Remote Control">
                <Basic.StringInput name="Start hashtag" value={startHashtag} setValue={setStartHashtag} />
                <Basic.StringInput name="Stop hashtag" value={stopHashtag} setValue={setStopHashtag} />
                <Basic.PositiveIntegerInput name="Min hastags" value={minHashtags} setValue={setMinHashtags} />
                <Basic.SelectInput name="Freqnecy per viewer" value={hashtagRate} setValue={setHashtagRate}
                                   options={[
                                { label: "One time only", value: "one_per_user" },
                                { label: "Once every 10 seconds", value: "one_every_10_seconds" },
                                { label: "Once every minute", value: "one_every_minute" },
                                { label: "Unlimited", value: "unlimited" },
                            ]}
                />
            </SettingsGroup>

            <DataListModal modalTitle="Items list"
                           showModal={showModal}
                           setShowModal={setShowModal}
                           modalOpen={modalOpen}
                           list={presetList}
                           setList={setPresetList}
            />
        </>
    )
}

